export { default } from './PopupConfirm';


// WEBPACK FOOTER //
// ./src/components/shared/PopupConfirm/index.ts